module.exports = __webpack_public_path__ + "static/media/focus-main-2.140e79ad.jpg";